module.exports = __webpack_public_path__ + "static/media/carousel3bg.9c9d358e.png";